import { Editor, Element, NodeEntry, Range } from "slate";

import parseEmailText from "./parseEmailText";

const decorator = (editor: Editor, [node, path]: NodeEntry): Range[] => {
  if (!("text" in node)) {
    return [];
  }

  const [parentNode] = Editor.parent(editor, path);
  if (Element.isElement(parentNode) && parentNode.type === "link") {
    return [];
  }

  return parseEmailText(node.text).map((link) => {
    return {
      anchor: {
        offset: link.index ?? 0,
        path,
      },
      decoration: link.type,
      focus: {
        offset: (link.index ?? 0) + link.length,
        path,
      },
    };
  });
};

export default decorator;
